<template>
    <div class="flex-fill">
        <div style="color: #616161; font-size: 0.85rem">
            <div :key="element.id" v-for="element in listData"
                :style="`${element.type === dict.transactionType.PROCESSING ? '#616161' : 'background-color: #F4FAF4'}`">
                <el-card class="mb-1 mt-1">
                    <div>
                        <div class="v-center text-nowrap text-left">
                            <div class="d-flex flex-row align-items-start">
                                <div class=" d-flex flex-row align-items-center justify-content-center mr-1 ">
                                    <img style="width: 2rem" class="mt-1"
                                        :src="`/providerTransaction/${element.paymentMethodId}.svg`" />
                                </div>
                                <div class="ml-1 flex-fill">
                                    <div class="d-flex align-items-start">
                                        <div class="flex-fill">
                                            <div class="d-flex align-items-center"> 
                                                <div class="text-nowrap text-left">
                                                    <div style="font-weight: 500"
                                                        :style="`color: ${element.type === dict.transactionType.PROCESSING ? '#616161' : 'forestgreen'}`">
                                                        <span>${{ element.amount }}</span> <span class="texxt-muted ml-2">⮕</span>
                                                    </div>
                                                </div>
                                                <div class="text-nowrap text-left ml-2">
                                                    <div title="iRender point"
                                                        class=" d-flex justify-content-end align-items-center flex-row "
                                                        :style="`${element.irenderPoint === 0 ? 'opacity: 0.25' : ''}`">
                                                        <div style="color: #42a5f5">
                                                            {{ element.irenderPoint }}
                                                        </div>
                                                        <img class="ml-1" style="opacity: 0.75" src="/static/image/logo-irender-coin.svg"
                                                            width="12" height="12" />
                                                    </div>
                                                </div>
                                                <div class="text-nowrap text-left ml-3">
                                                    <div title="Bonus point"
                                                        class=" d-flex justify-content-end align-items-center flex-row"
                                                        :style="`${element.bonusPoint === 0 ? 'opacity: 0.25' : ''}`">
                                                        <div class="text-muted">
                                                            {{ element.bonusPoint }}
                                                        </div>
                                                        <i class="el-icon-coin ml-1" style="margin-top: 0.2rem"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="font-weight: 500; line-height: 0.75rem;" 
                                                :style="`${element.type === dict.transactionType.PROCESSING
                                                ? 'color: #757575;'
                                                : 'color: forestgreen; text-shadow: 2px 2px #ffffff;'
                                                }`">
                                                <small>{{ element.paymentMethodDescription }}</small>
                                            </div>
                                            <div>                                        
                                                <small v-if="element.transactionId" 
                                                    style="text-shadow: 2px 2px #ffffff; color: #9e9e9e; line-height: 0.75rem;">
                                                    {{ element.transactionId }}
                                                </small>
                                            </div>
                                            <div style="font-size: 0.75rem; color: #9e9e9e; line-height: 0.75rem;">
                                                <small>{{ element.lastModifiedAt | pretyDateUtcToLocal }}</small>
                                            </div>
                                        </div>
                                        <div class="v-center text-nowrap text-left">
                                            <div> 
                                                <span :class="`d-inline-block ${dict.paymentStyleStatusText[element.status]}`"
                                                    style="padding: 0.25rem 0.5rem; border-radius: 1rem; font-size: 90%;">
                                                    <i :class="`${dict.paymentStatusIcon[element.status]}`" style="font-size: 0.8rem"></i>
                                                    <span class="ml-1">{{
                                                        dict.paymentStatusText[element.status]
                                                        }}</span>
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="v-center text-nowrap"> 
                                        
                                    </div>
                                </div>
                            </div>
                        </div>  
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        listData: {
            type: Array,
            default() {
                return []
            }
        },
        dict: {
            type: Object,
            default() {
                return {}
            }
        },
        actions: {
            type: Object,
            default() {
                return {}
            }
        },
    }
}
</script>